import { Header } from "./components/Header/Header.js";
import { StatusBar } from "./components/StatusBar/StatusBar.js";
import { Sidebar } from "./components/Sidebar/Sidebar.js";
import { Toaster } from "./components/Toaster/Toaster.js";
import { AppState } from "./store/AppState.js";

// Import des pages
import { ValidationConflits } from "./pages/ValidationConflits/ValidationConflits.js";
import { GenerationRapport } from "./pages/GenerationRapport/GenerationRapport.js";

import { ConfigGlobal } from "./pages/ConfigGlobal/ConfigGlobal.js";

export class App {
  constructor() {
    this.state = new AppState();
    this.currentPage = "config-global";
    this.components = {};
    this.pages = {};
    this.currentPageInstance = null;

    // Récupérer la version via Vite
    this.version = this.getAppVersion();

    this.toaster = new Toaster();
    this.setupToasterIntegration();

    this.initPages();
    this.initComponents();
    this.bindEvents();
  }

  getAppVersion() {
    // Utiliser la variable injectée par Vite
    if (typeof __APP_VERSION__ !== "undefined") {
      return __APP_VERSION__;
    }

    // Fallback par défaut (correspond à votre package.json actuel)
    return "9.9.9";
  }

  setupToasterIntegration() {
    this.state.addToasterMessage = (type, message) => {
      this.toaster.addMessage(type, message);
    };
  }

  initPages() {
    this.pages = {
      "config-global": new ConfigGlobal(this.state),
      /*
      "config-tiroirs": new ConfigTiroirs(this.state),
      "base-rop": new BaseROP(this.state),
      "rapport-fiber-pv-reussite": new FiberCableDistribPvResussite(this.state),
      "pv-reussite": new PvReussite(this.state),
      "rapport-fiber-pv-echec": new FiberCableDistribPvEchec(this.state),
      "pv-echec": new PvEchec(this.state),
      "pv-hs": new PvHs(this.state),
      "resultats-analyse": new ResultatsAnalyse(this.state),
      */
      "rapport-final": new GenerationRapport(this.state),
      "validation-conflits": new ValidationConflits(this.state),
    };
  }

  initComponents() {
    this.components = {
      header: new Header(),
      statusBar: new StatusBar(this.state),
      sidebar: new Sidebar(this.state),
    };
  }

  bindEvents() {
    // Écouter les changements de page
    this.state.on("pageChanged", (page) => {
      this.navigateTo(page);
    });

    // Écouter les changements d'état
    this.state.on("stateChanged", () => {
      this.components.statusBar.render();
    });
  }

  navigateTo(pageId) {
    this.currentPage = pageId;
    this.renderWorkspace();
  }

  renderWorkspace() {
    const workspace = document.querySelector(".workspace-content");
    if (!workspace || !this.pages[this.currentPage]) {
      return;
    }

    // Démonter la page précédente si elle existe
    if (this.currentPageInstance && typeof this.currentPageInstance.unmount === "function") {
      this.currentPageInstance.unmount();
    }

    // Vider le workspace
    workspace.innerHTML = "";

    // Récupérer la nouvelle page
    const pageInstance = this.pages[this.currentPage];
    this.currentPageInstance = pageInstance;

    // Vérifier si la page a une méthode mount (nouvelle approche)
    if (typeof pageInstance.mount === "function") {
      // Nouvelle approche : utiliser mount()
      pageInstance.mount(workspace);
    } else {
      // Ancienne approche : utiliser innerHTML
      workspace.innerHTML = pageInstance.render();
    }
  }

  render() {
    return `
      <div class="app-container">
        <div class="header-container"></div>
        <div class="status-bar-container"></div>
        <div class="main-content">
          <div class="sidebar-container"></div>
          <div class="workspace">
            <div class="workspace-content"></div>
          </div>
        </div>
        <div class="footer">
          <span>Version ${this.version} • SMART-PM, un outil de validation automatique des dossiers de réflectométrie.</span>
        </div>
      </div>
    `;
  }

  mount(selector) {
    const container = document.querySelector(selector);
    if (!container) {
      throw new Error(`Container ${selector} not found`);
    }

    // Injecter le HTML principal
    container.innerHTML = this.render();

    // Monter les composants
    this.components.header.mount(".header-container");
    this.components.statusBar.mount(".status-bar-container");
    this.components.sidebar.mount(".sidebar-container");

    // Rendre la page initiale
    this.renderWorkspace();
  }

  /**
   * Nettoyer les ressources lors de la fermeture
   */
  destroy() {
    // Démonter la page courante
    if (this.currentPageInstance && typeof this.currentPageInstance.unmount === "function") {
      this.currentPageInstance.unmount();
    }

    // Démonter les composants
    Object.values(this.components).forEach((component) => {
      if (typeof component.unmount === "function") {
        component.unmount();
      }
    });

    // Nettoyer les pages
    Object.values(this.pages).forEach((page) => {
      if (typeof page.destroy === "function") {
        page.destroy();
      }
    });

    if (this.toaster) {
      this.toaster.destroy();
    }
  }
}
